module.exports = __webpack_public_path__ + "media/images/icons/arrow-top-16affb894ffbc87669ae1304392e7296.svg";